import { render } from "./GroupActions.vue?vue&type=template&id=0e97489c"
import script from "./GroupActions.vue?vue&type=script&lang=js"
export * from "./GroupActions.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__